
import { CalendarProvider } from "../../components/business/calendar/calendarContext.js";
import PrintView from "../../components/business/calendar/print/printView.js"; 
import Portal from "../../../../platform/pages/business/portal";

 const PrintPortal = (props) => {
    return (
        <CalendarProvider myBookingTypes={props.myBookingTypes}>
            <Portal TabComponent={PrintView} />
        </CalendarProvider>
    );
};
export default PrintPortal;
